import { defineComponent as B, useCssModule as b, useSlots as z, computed as l, resolveComponent as S, createElementBlock as _, openBlock as m, normalizeClass as n, unref as s, createElementVNode as o, createVNode as p, createCommentVNode as V, withCtx as h, toDisplayString as a, createTextVNode as c, renderSlot as X } from "vue";
import { t } from "./locale.js";
import I from "./Button.js";
import { _ as N, V as $, I as M } from "./Illustration.vue_vue_type_script_setup_true_lang-BBqgoJO8.js";
import { _ as T } from "./Logo.vue_vue_type_script_setup_true_lang-Dz8c98sc.js";
import { _ as D } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const H = { class: "heading-jumbo tw-m-0 tw-mb-3 !tw-text-white" }, j = { class: "tw-mb-8 tw-text-white" }, F = { class: "tw-mb-4 tw-text-white" }, R = ["href"], Y = {
  key: 0,
  class: "tw-flex tw-items-start tw-gap-6"
}, q = /* @__PURE__ */ B({
  __name: "HttpError",
  props: {
    description: { default: "" },
    errorCode: { default: "404" },
    hideLogoutButton: { type: Boolean, default: !1 },
    onLogout: { type: Function, default: void 0 },
    retryLink: { default: void 0 },
    title: { default: "" }
  },
  setup(f) {
    const d = {
      401: {
        title: t("ll.httpError.401.title"),
        description: t("ll.httpError.401.description")
      },
      403: {
        title: t("ll.httpError.403.title"),
        description: t("ll.httpError.403.description")
      },
      404: {
        title: t("ll.httpError.404.title"),
        description: t("ll.httpError.404.description")
      },
      405: {
        title: t("ll.httpError.405.title"),
        description: t("ll.httpError.405.description")
      },
      500: {
        title: t("ll.httpError.50X.title"),
        description: t("ll.httpError.50X.description")
      },
      502: {
        title: t("ll.httpError.50X.title"),
        description: t("ll.httpError.50X.description")
      },
      503: {
        title: t("ll.httpError.50X.title"),
        description: t("ll.httpError.50X.description")
      },
      504: {
        title: t("ll.httpError.504.title"),
        description: t("ll.httpError.504.description")
      }
    }, r = f, i = b(), w = z(), E = l(() => r.errorCode.toString()), g = l(() => parseInt(E.value, 10)), u = l(() => d[g.value] || d[500]), v = l(() => r.title || u.value.title), y = l(() => r.description || u.value.description), k = l(() => !r.hideLogoutButton && r.onLogout), C = l(() => r.retryLink || window.location.href);
    return (x, e) => {
      const L = S("router-link");
      return m(), _("div", {
        class: n(["stash-http-error tw-px-6 tw-py-12", s(i).root]),
        "data-test": "stash-http-error"
      }, [
        o("div", {
          class: n(s(i).wrapper)
        }, [
          p(L, {
            to: "/",
            class: "tw-mb-8 tw-block"
          }, {
            default: h(() => [
              p(T, {
                color: "white",
                width: "192"
              })
            ]),
            _: 1
          }),
          o("div", {
            class: n(["tw-mb-8 tw-gap-6", s(i).content])
          }, [
            o("div", {
              class: n(["tw-order-2 lg:tw-order-1", s(i).content__text])
            }, [
              o("h1", H, a(v.value), 1),
              o("h2", j, "Error Code: " + a(r.errorCode), 1),
              o("p", F, [
                c(a(y.value) + " You can ", 1),
                o("a", {
                  href: C.value,
                  class: "link"
                }, "try again", 8, R),
                e[0] || (e[0] = c(" or reach out to ")),
                e[1] || (e[1] = o("a", {
                  href: "mailto:support@leaflink.com",
                  class: "link"
                }, "support@leaflink.com", -1)),
                e[2] || (e[2] = c(" for assistance. "))
              ])
            ], 2),
            o("div", {
              class: n(["tw-order-1 lg:tw-order-2", s(i).illustration])
            }, [
              p(N, {
                size: 300,
                type: s(M).Vignette,
                name: s($).SearchStorefront
              }, null, 8, ["type", "name"])
            ], 2)
          ], 2),
          s(w).actions || k.value ? (m(), _("div", Y, [
            X(x.$slots, "actions", {}, () => [
              p(I, {
                tertiary: "",
                onClick: r.onLogout
              }, {
                default: h(() => e[3] || (e[3] = [
                  c("Logout")
                ])),
                _: 1
              }, 8, ["onClick"])
            ])
          ])) : V("", !0)
        ], 2)
      ], 2);
    };
  }
}), A = "_root_16z1p_2", G = "_wrapper_16z1p_11", J = "_content_16z1p_16", K = "_illustration_16z1p_22", O = "_content__text_16z1p_40", P = {
  root: A,
  wrapper: G,
  content: J,
  illustration: K,
  content__text: O
}, Q = {
  $style: P
}, et = /* @__PURE__ */ D(q, [["__cssModules", Q]]);
export {
  et as default
};
//# sourceMappingURL=HttpError.js.map
